const Data = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M16.6667 11.6663C17.5871 11.6663 18.3333 10.9201 18.3333 9.99967C18.3333 9.0792 17.5871 8.33301 16.6667 8.33301C15.7462 8.33301 15 9.0792 15 9.99967C15 10.9201 15.7462 11.6663 16.6667 11.6663Z"
        stroke={color}
        strokeWidth="1.15385"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 5.00033C17.5871 5.00033 18.3333 4.25413 18.3333 3.33366C18.3333 2.41318 17.5871 1.66699 16.6667 1.66699C15.7462 1.66699 15 2.41318 15 3.33366C15 4.25413 15.7462 5.00033 16.6667 5.00033Z"
        stroke={color}
        strokeWidth="1.15385"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 18.3333C17.5871 18.3333 18.3333 17.5871 18.3333 16.6667C18.3333 15.7462 17.5871 15 16.6667 15C15.7462 15 15 15.7462 15 16.6667C15 17.5871 15.7462 18.3333 16.6667 18.3333Z"
        stroke={color}
        strokeWidth="1.15385"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33464 11.6663C4.25511 11.6663 5.0013 10.9201 5.0013 9.99967C5.0013 9.0792 4.25511 8.33301 3.33464 8.33301C2.41416 8.33301 1.66797 9.0792 1.66797 9.99967C1.66797 10.9201 2.41416 11.6663 3.33464 11.6663Z"
        stroke={color}
        strokeWidth="1.15385"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 10H15" stroke={color} strokeWidth="1.15385" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M15.0013 3.33301H11.668C10.0013 3.33301 9.16797 4.16634 9.16797 5.83301V14.1663C9.16797 15.833 10.0013 16.6663 11.668 16.6663H15.0013"
        stroke={color}
        strokeWidth="1.15385"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Data;
